import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { get, flowRight as compose } from 'lodash';

import { QUERY_GET_CONNECTION_PROVIDER } from './gql';
import withAuth from '../../../../hocs/withAuth';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

class ConnectorProvider extends React.Component {
  getData = () => {
    const { connectionProvider, auth } = this.props;
    const connectorConnectionProviders = get(connectionProvider, 'AdminQueries.getConnectors', []);

    return {
      connectionProvider: connectorConnectionProviders,
      admin: auth.me
    };
  };

  getError = () => {
    const { connectionProvider } = this.props;
    return {
      connectionError: connectionProvider.error
    };
  };

  getLoading = () => {
    const { connectionProvider } = this.props;
    return {
      connectionLoading: connectionProvider.loading
    };
  };

  render() {
    const { children } = this.props;
    const renderProps = {
      data: this.getData(),
      error: this.getError(),
      loading: this.getLoading()
    };
    return children(renderProps);
  }
}

ConnectorProvider.propTypes = {
  children: ReactChildrenPropType.isRequired,
  connectionProvider: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.shape({}),
    refetch: PropTypes.func
  }).isRequired,
  auth: PropTypes.shape({
    me: PropTypes.shape({})
  }).isRequired
};

export const ConnectorProviderContainer = compose(
  withAuth(),
  graphql(QUERY_GET_CONNECTION_PROVIDER, {
    name: 'connectionProvider',
    options: () => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: (props) => props
  })
)(ConnectorProvider);
